<template>
  <div class="disqus">
    <div class="container">
      <div class="row-md justify-center">
        <div class="col-md-8">
          <disqus
            v-if="pageConfig"
            shortname="asphalte-dev"
            :page-config="pageConfig"
            :lang="$i18n.locale.substring(0, 2)"
            lazy
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line
import { Disqus } from 'vue-disqus'

export default {
  name: 'CommentsDisqus',
  components: {
    Disqus,
  },
  props: {
    articleId: { type: String, required: true },
  },
  data() {
    return {
      pageConfig: false,
    }
  },
  mounted() {
    this.pageConfig = {
      url: `https://asphalte.com${this.$nuxt.$route.path}`,
      identifier: this.articleId,
    }
  },
}
</script>

<style lang="scss">
.disqus {
  background: var(--secondary-color-5);
  padding: rem($spacing * 2) 0;

  @include mq($from: tablet) {
    padding: rem($spacing * 10) 0;
  }
}
</style>
